import React from 'react';

import { flagStyles } from '../settings';

const SvgAM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-144px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAM;
